import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import utils from 'helpers/utils';
import styled from 'styled-components';

const StyledErrorMessage = styled.div`
    position: relative;
    padding-top: 2rem;
    bottom: 1.5rem;
    font-size: 1.2rem;
    line-height: 1;
    color: rgb(244, 67, 54);
    transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
`;

const DefaultRadioButtonGroupField = (props) => {
    const {
        checkedIcon,
        disabled,
        input: { name, onChange, value },
        label,
        meta: {
            error,
            touched,
        },
        options,
        style,
        uncheckedIcon,
    } = props;

    const selectedOption = utils.find(options, (option) => {
        return option.value == value;
    });

    return (
        <div style={ style }>
            <RadioButtonGroup
                disabled={ disabled }
                label={ label }
                labelPosition='right'
                name={ name }
                onChange={ onChange }
                style={ style }
                valueSelected={ selectedOption ? selectedOption.value : '' }
            >
                { utils.map(options, (option, key) => {
                    return (
                        <RadioButton
                            key={ `radio-button-${ key }` }
                            checkedIcon={ checkedIcon }
                            label={ option.label }
                            value={ option.value }
                            style={ { marginBottom: 10 } }
                            uncheckedIcon={ uncheckedIcon }
                        />
                    );
                }) }
            </RadioButtonGroup>

            {
                (touched && error) && (
                    <StyledErrorMessage>
                        { error }
                    </StyledErrorMessage>
                )
            }
        </div>
    );
};

DefaultRadioButtonGroupField.propTypes = {
    checkedIcon: PropTypes.element,
    disabled: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onDragStart: PropTypes.func.isRequired,
        onDrop: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
            PropTypes.bool,
        ]),
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.string,
        touched: PropTypes.bool,
    }),
    options: PropTypes.oneOfType([
        PropTypes.objectOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string,
                    PropTypes.bool,
                ]),
            }),
        ),
        PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string,
                    PropTypes.bool,
                ]),
            }),
        ),
    ]).isRequired,
    style: PropTypes.object,
    uncheckedIcon: PropTypes.element,
};

export default DefaultRadioButtonGroupField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/DefaultRadioButtonGroupField.js